// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  crewId: __t.u64().primaryKey().name("crew_id"),
  captain: __t.identity(),
  crew: __t.identity(),
  seat: __t.string(),
  systemId: __t.string().name("system_id"),
  since: __t.timestamp(),
  updatedAt: __t.timestamp().name("updated_at"),
});
